import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import BrandSection from './components/BrandSection';
import TestimonialSection from './components/TestimonialSection';
import ContactCTA from './components/ContactCTA';

const wpJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于我们 - 韩漫漫画网',
  description: '韩漫漫画网是优质韩漫阅读平台，汇聚2500+韩国漫画资源，提供高清流畅的免费在线阅读体验。了解品牌故事、用户口碑与联系方式。',
  url: 'http://ihua3.com/about',
};

export default function AboutPage() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(wpJsonLd)}</script>
      <SEOHead
        title="关于我们_韩漫漫画网_免费韩漫在线阅读平台"
        description="韩漫漫画网是优质韩漫阅读平台，汇聚2500+韩国漫画资源，八大品类全覆盖，高清画质极速加载。了解品牌故事、用户口碑与联系方式。"
        keywords="韩漫漫画网,关于我们,韩漫平台,韩国漫画,联系我们"
        canonicalUrl="http://ihua3.com/about"
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-4">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>
        <BrandSection />
        <TestimonialSection />
        <ContactCTA />
      </main>
      <Footer />
    </>
  );
}